import { createAsyncThunk } from '@reduxjs/toolkit'
import Comment from './comment-model'
import { delete_comment, load_comments, store_comment } from './comment-service'

export const LoadCommentsAsync = createAsyncThunk<any, any>(
  'composer/load/comment',
  async (params: { uid: string }) => {
    return await load_comments(params)
  },
)

export const CreateCommentAsync = createAsyncThunk<any, any>(
  'composer/create/comment',
  async (params: Comment) => {
    return await store_comment(params)
  },
)

export const DeleteCommentAsync = createAsyncThunk<any, any>(
  'composer/delete/comment',
  async (params) => {
    return await delete_comment(params)
  },
)
